import React from 'react'
import Logo from '../Assets/Images/proton.png'
import { Link, Links, useNavigate } from 'react-router-dom';
import '../Assets/Styles/Navbar.css'
const NavbarTop = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn'); // Clear login state
    navigate('/', { replace: true }); // Redirect to Login page
    localStorage.removeItem("adminToken");
    localStorage.removeItem("role");
  };
  return (
    <div>
    <nav className="navbar navbar-expand-lg ">
      <div className="container">
        <Link to={"/"} className="navbar-brand" href="#">
          <img src={Logo} alt="" className="logo" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link to={"/"} className="nav-link active" aria-current="page" href="#">
                Home
              </Link>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownEmail"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Segmented Email
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdownEmail">
                <li>
                  <Link to="segmented-en" className="dropdown-item" >
                    English
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link to="segmented-fr" className="dropdown-item">
                    French
                  </Link>
                </li>
              </ul>
            </li>
           <div></div>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownPromo"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Promotional Email
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdownPromo">
                <li>
                  <Link to={"promotional-en"} className="dropdown-item" >
                    English
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link to={"promotional-fr"} className="dropdown-item" href="#">
                    French
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <div onClick={handleLogout} className="nav-link active" aria-current="page" href="#">
                Logout
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
  
  )
}

export default NavbarTop